import React, { useState, useRef, useEffect } from 'react'
import { connect } from 'react-redux'
import { Col, Container } from 'react-bootstrap'
import { useFormik } from 'formik'
import FeatherIcon from 'feather-icons-react';
import { toast } from 'react-toastify';
import { setGlobalLoading } from 'redux/actions/actionCommon'
import {
    UNKNOWN_ERROR_OCCURED,
    ERROR_WHILE__NAME,
} from 'utlis/AppMessages/AppMessages'

import { getCustomerCountries } from 'utlis/Apis/Customers_API'
import DestinationZonesDetails from './Includes/DestinationZonesDetails'
import DestinationZoneTopBar from './Includes/DestinationZoneTopBar'

function DestinationZones(props) {
    const detailsSubmitRef = useRef(null)
    const [createButtonLoading, setCreateButtonLoading] = useState(false)

    const [countries, setCountries] = useState([])
    const [step, setStep] = useState(1)

    useEffect(() => {
        getCountries_()
    }, [props.currentUser.customerToken])
    const getCountries_ = () => {
        getCustomerCountries().then(res => {
            const countriesData = res.data
            if (countriesData.success) {
                setCountries(countriesData.data)
            }
            if (countriesData.error) {
                console.log('Error occured while loading countries groups!', res)
            }
        }).catch(err => {
            console.log(`${ERROR_WHILE__NAME} getCountries `, err.message)
            toast.dismiss();
            toast.error(UNKNOWN_ERROR_OCCURED, {
                autoClose: 2500
            })
        })
    }

    const formik = useFormik({
    })
    const SideBarItem = ({ name, n }) => {
        return (<div className={`shrunk  ${step === n ? "border-bottom st-border-light" : "border-bottom st-border-light"}`} onClick={() => { setStep(n) }}>
            <div className={`customer-sidebar-item ${step === n ? "customer-active-sidebar-item" : ""}`} >
                <div className="top-sec d-flex align-items-center" >
                    {step === n ? <FeatherIcon
                        icon="disc"
                        size="8"
                        className="icon me-2" /> :
                        <FeatherIcon
                            icon="circle"
                            size="8"
                            className="icon me-2" />
                    }
                    <span>{name}</span>
                </div>
            </div>
        </div>)
    }
    const sideBarItems = ["United States", "Us & Canada"]

    return (
        <section id="app-customers__create-details" className="st-def-mar-TB page-eorc-wrapper">
            <Container fluid className="st-container">
                <div className="app-customers__create-details ">
                    <div className="app-header-wrapper mb-3">
                        <p className="app-heading text-capitalize">Destination Zones</p>
                    </div>
                    <div className="app-card customer">
                        <div className="app-card-content bg-white border st-default-rounded-block mb-3 pad-12-T pad-12-B">
                            <div className="app-content-container categories-wrapper">
                                <DestinationZoneTopBar
                                    step={step}
                                    setStep={(s) => { setStep(s) }}
                                    loading={createButtonLoading}
                                />
                            </div>
                            <div className="categories-wrapper-inner d-flex flex-wrap">
                                <div className="customer-sidebar">
                                    <div className="inner">
                                        {sideBarItems.map((e, index) => <SideBarItem name={e} n={index + 1} key={index} />)}
                                    </div>
                                </div>
                                <div className="category-data-view media-body position-relative bg-white  pad-20-L pad-20-R">
                                    {step === 1 ? <Col xs={12} md={12} lg={12} className="px-0">
                                        <div className="pad-12-L pad-12-B pad-12-R pad-25-T">
                                            <div className="app-card customer-form">
                                                <div className="app-card-content border st-default-rounded-block mb-3 pad-12-T pad-12-B pad-12-R pad-12-L">
                                                    <div className="app-card mb-3 mb-lg-4">
                                                        <div className="app-card-content  pad-20-LR pad-20-T">
                                                            <Col xs={12} md={9} lg={11} className="px-0">
                                                                <form
                                                                    noValidate
                                                                    autoComplete="off">
                                                                    <DestinationZonesDetails
                                                                        formik={formik}
                                                                        countries={countries}
                                                                    />
                                                                    <button
                                                                        ref={detailsSubmitRef}
                                                                        type="submit"
                                                                        id="customerAddress"
                                                                        className="d-none">submit</button>
                                                                </form>
                                                            </Col>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </Col> : ""
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </div >
            </Container >
        </section >
    )
}


const getDataFromStore = state => {
    return {
        currentUser: state.auth.currentUser
    };
}

const dispatchActionsToProps = dispatch => {
    return {
        setGlobalLoading: bool => dispatch(setGlobalLoading(bool)),
    }
}

export default connect(getDataFromStore, dispatchActionsToProps)(DestinationZones)